// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.show-search-conditions-pop .show-search-conditions-tags {
  display: -webkit-inline-flex;
  display: inline-flex;
  overflow: hidden;
  max-width: 320px;
  min-width: 40px;
  text-align: left;
  word-break: break-all;
  margin: 4px 4px;
  color: #666;
  border-color: #DBE0E5;
  background-color: transparent;
  border-radius: 3px;
}
.show-search-conditions-pop .show-search-conditions-tags .wui-tag-text {
  -webkit-flex-shrink: 1;
          flex-shrink: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.show-search-conditions-pop .show-search-conditions-tags .uf-close {
  color: #ADB4BC;
}
.refer-container {
  width: 100%;
}
.refer-input-pc-box {
  width: 100%;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
          align-items: center;
}
.refer-input-pc-box .refer-icon {
  cursor: pointer ;
}
.refer-input-pc-box .refer-clear {
  display: none;
}
.refer-input-pc-box .wui-input-affix-wrapper {
  color: var(--wui-input-suffix-icon-color);
  padding-left: 0px;
}
.refer-input-pc-box .wui-input-affix-wrapper .wui-input-suffix.has-close {
  position: absolute;
  right: 24px;
  top: 2px;
}
.refer-input-pc-box .wui-input-affix-wrapper .wui-input,
.refer-input-pc-box .wui-input-affix-wrapper .wui-input-simple-suffix {
  height: auto;
}
.refer-input-pc-box .wui-input-simple-prefix {
  max-width: calc(100% - 50px);
}
.refer-input-pc-box .wui-tag {
  margin-right: 4px;
}
.refer-input-pc-box .uf-close-c {
  cursor: pointer;
}
.refer-input-pc-box .wui-popover-inner {
  padding: 0;
}
.refer-input-pc-box.no-refcode input::-webkit-input-placeholder {
  color: #FF5735;
}
.refer-input-pc-box.no-refcode input:-ms-input-placeholder {
  color: #FF5735;
}
.refer-input-pc-box.no-refcode input::placeholder {
  color: #FF5735;
}
.refer-input-pc-box:hover .refer-clear {
  display: block;
}
.refer-tag-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
          align-items: center;
  width: 100%;
}
.refer-tag-container .refer-prefix {
  margin-right: 2px;
  white-space: "nowrap";
}
.refer-tag-container .ynf-mul-tag {
  white-space: nowrap;
  max-width: 100%;
}
.refer-tag-container .ynf-mul-tag .ynf-mul-tag-span {
  display: inline-block;
  height: 20px;
  line-height: 20px;
  padding: 0 8px;
  background-color: #e7f0fb;
  margin-right: 4px;
  font-size: 12px;
}
.refer-tag-container .ynf-mul-tag .ynf-mul-tag-browse {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* 设置最大显示行数 */
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  white-space: break-spaces;
}
.refer-input-pc-box .wui-input-affix-wrapper .wui-input-simple-prefix :focus,
.refer-input-pc-box .wui-input-affix-wrapper .wui-input-simple-prefix :hover,
.refer-input-pc-box .wui-input-affix-wrapper .wui-input-simple-suffix :focus,
.refer-input-pc-box .wui-input-affix-wrapper .wui-input-simple-suffix :hover {
  color: #9ca3af;
}
.refer-input-pc-box .uf-close {
  font-size: 9px;
  padding-right: 0;
}
.ynf-refer-popover {
  position: fixed;
}
.ynf-refer-popover .wui-popover-inner {
  padding: 0;
}
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-thumb {
  width: 8px;
  height: 121px;
  background: #cdd9e6;
  border-radius: 4px;
}
.refer-model-body {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
          flex-direction: column;
  height: 100%;
}
.refer-model-body .yb-layout {
  -webkit-flex: 1 1;
          flex: 1 1;
  overflow: hidden;
}
.refer-model-body .yb-layout > .ynf-lib-base--box {
  width: 200px !important;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
          flex-direction: column;
}
.refer-model-body .ynf-lib-base-tree-box {
  -webkit-flex: 1 1;
          flex: 1 1;
  border-right: 1px solid #eee;
}
.refer-model-body .ynf-lib-base-tree-box > div {
  padding: 2px 10px !important;
}
.refer-model-body .ynf-lib-base-tree-box + .yb-table {
  overflow: hidden;
  -webkit-flex: 4 1;
          flex: 4 1;
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/index.less","webpack://./src/components/ReferInputPcNew/assests/index.less"],"names":[],"mappings":"AAOA;EAEI,4BAAA;EAAA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,6BAAA;EACA,kBAAA;ACPJ;ADLA;EAeM,sBAAA;UAAA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;ACPN;ADXA;EAsBM,cAAA;ACRN;AApBA;EACE,WAAA;AAsBF;AAnBA;EACE,WAAA;EACA,qBAAA;EAAA,aAAA;EACA,2BAAA;UAAA,mBAAA;AAqBF;AAxBA;EAKI,gBAAA;AAsBJ;AA3BA;EAQI,aAAA;AAsBJ;AA9BA;EAYI,yCAAA;EACA,iBAAA;AAqBJ;AAlCA;EAgBM,kBAAA;EACA,WAAA;EACA,QAAA;AAqBN;AAvCA;;EAuBM,YAAA;AAoBN;AA3CA;EA4BI,4BAAA;AAkBJ;AA9CA;EAgCI,iBAAA;AAiBJ;AAjDA;EAoCI,eAAA;AAgBJ;AApDA;EAuCI,UAAA;AAgBJ;AAbA;EACuB,cAAA;AAevB;AAhBA;EACuB,cAAA;AAevB;AAhBA;EACuB,cAAA;AAevB;AAZA;EAEI,cAAA;AAaJ;AATA;EACE,qBAAA;EAAA,aAAA;EACA,2BAAA;UAAA,mBAAA;EACA,WAAA;AAWF;AAdA;EAMI,iBAAA;EACA,qBAAA;AAWJ;AAlBA;EAWI,mBAAA;EACA,eAAA;AAUJ;AAtBA;EAeM,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AAUN;AA/BA;EAyBM,gBAAA;EACA,oBAAA;EACA,qBAAA;EASJ,aAAa;EART,4BAAA;EACA,uBAAA;EACA,yBAAA;AAUN;AAJA;;;;EAUI,cAAA;AAAJ;AAVA;EAwBI,cAAA;EACA,gBAAA;AAXJ;AAeA;EACE,eAAA;AAbF;AAYA;EAGI,UAAA;AAZJ;AAiBC;EACC,UAAA;AAfF;AA+BC;EACC,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AA7BF;AAyCA;EACE,qBAAA;EAAA,aAAA;EACA,8BAAA;UAAA,sBAAA;EACA,YAAA;AAvCF;AAoCA;EAKI,iBAAA;UAAA,SAAA;EACA,gBAAA;AAtCJ;AAyCI;EACE,uBAAA;EACA,qBAAA;EAAA,aAAA;EACA,8BAAA;UAAA,sBAAA;AAvCN;AA2BA;EAiBI,iBAAA;UAAA,SAAA;EACA,4BAAA;AAzCJ;AA0CI;EACE,4BAAA;AAxCN;AAoBA;EAyBI,gBAAA;EACA,iBAAA;UAAA,SAAA;AA1CJ","sourcesContent":["// 样式变量定义\n// @theme: #f53c32;\n\n// 公共样式\n// body{\n//     background-color: #ffffff;\n// }\n.show-search-conditions-pop {\n  .show-search-conditions-tags {\n    display: inline-flex;\n    overflow: hidden;\n    max-width: 320px;\n    min-width: 40px;\n    text-align: left;\n    word-break: break-all;\n    margin: 4px 4px;\n    color: #666;\n    border-color: #DBE0E5;\n    background-color: transparent;\n    border-radius: 3px;\n\n    .wui-tag-text {\n      flex-shrink: 1;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n\n    .uf-close {\n      color: #ADB4BC;\n    }\n  }\n}","@import \"../../../assets/style/index.less\";\n.refer-container {\n  width: 100%;\n}\n\n.refer-input-pc-box {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  .refer-icon {\n    cursor: pointer ;\n  }\n  .refer-clear {\n    display: none;\n  }\n\n  .wui-input-affix-wrapper {\n    color: var(--wui-input-suffix-icon-color);\n    padding-left: 0px;\n\n    .wui-input-suffix.has-close {\n      position: absolute;\n      right: 24px;\n      top: 2px;\n    }\n\n    .wui-input,\n    .wui-input-simple-suffix {\n      height: auto;\n    }\n  }\n\n  .wui-input-simple-prefix {\n    max-width: calc(100% - 50px);\n  }\n\n  .wui-tag {\n    margin-right: 4px;\n  }\n\n  .uf-close-c {\n    cursor: pointer;\n  }\n  .wui-popover-inner {\n    padding: 0;\n  }\n}\n.refer-input-pc-box.no-refcode {\n  input::placeholder { color: #FF5735 }\n}\n\n.refer-input-pc-box:hover {\n  .refer-clear {\n    display: block;\n  }\n}\n\n.refer-tag-container {\n  display: flex;\n  align-items: center;\n  width: 100%;\n\n  .refer-prefix {\n    margin-right: 2px;\n    white-space: \"nowrap\";\n  }\n\n  .ynf-mul-tag {\n    white-space: nowrap;\n    max-width: 100%;\n\n    .ynf-mul-tag-span {\n      display: inline-block;\n      height: 20px;\n      line-height: 20px;\n      padding: 0 8px;\n      background-color: #e7f0fb;\n      margin-right: 4px;\n      font-size: 12px;\n    }\n\n    .ynf-mul-tag-browse {\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-line-clamp: 2; /* 设置最大显示行数 */\n      -webkit-box-orient: vertical;\n      text-overflow: ellipsis;\n      white-space: break-spaces;\n    }\n\n  }\n}\n\n.refer-input-pc-box {\n  // .ynf-mul-tag {\n  //   white-space: nowrap;\n  //   max-width: 100%;\n  // }\n\n  .wui-input-affix-wrapper .wui-input-simple-prefix :focus,\n  .wui-input-affix-wrapper .wui-input-simple-prefix :hover,\n  .wui-input-affix-wrapper .wui-input-simple-suffix :focus,\n  .wui-input-affix-wrapper .wui-input-simple-suffix :hover {\n    color: #9ca3af;\n  }\n\n  // .ynf-mul-tag-span {\n  //   display: inline-block;\n  //   height: 20px;\n  //   line-height: 20px;\n  //   padding: 0 8px;\n  //   background-color: #e7f0fb;\n  //   margin-right: 4px;\n  //   font-size: 12px;\n  // }\n\n  .uf-close {\n    font-size: 9px;\n    padding-right: 0;\n  }\n}\n\n.ynf-refer-popover {\n  position: fixed;\n  .wui-popover-inner {\n    padding: 0;\n  }\n}\n\n//滚动条整体部分\n&::-webkit-scrollbar {\n  width: 8px;\n}\n\n//滚动条两端的按钮\n&::-webkit-scrollbar-button {\n}\n\n// 外层轨道\n&::-webkit-scrollbar-track {\n}\n\n//内层轨道，滚动条中间部分（除去）\n&::-webkit-scrollbar-track-piece {\n}\n\n//滚动条里面可以拖动的那个\n&::-webkit-scrollbar-thumb {\n  width: 8px;\n  height: 121px;\n  background: #cdd9e6;\n  border-radius: 4px;\n}\n\n//边角\n&::-webkit-scrollbar-corner {\n}\n\n//定义右下角拖动块的样式\n&::-webkit-resizer {\n}\n\n// ----------------------------------\n.refer-model-body { // 后续整体调整样式\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  .yb-layout{\n    flex: 1;\n    overflow: hidden;\n  }\n  .yb-layout {\n    &>.ynf-lib-base--box {\n      width: 200px !important;\n      display: flex;\n      flex-direction: column;\n    }\n  }\n\n  .ynf-lib-base-tree-box {\n    flex: 1;\n    border-right: 1px solid #eee;\n    &>div {\n      padding: 2px 10px !important;\n    }\n  }\n\n  .ynf-lib-base-tree-box + .yb-table {\n    overflow: hidden;\n    flex: 4;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
